<template>
	<div class="modal question">
		<div class="modal-dialog">
			<div class="modal-content">
				<div class="modal-header">
					<div class="container">
						<div class="row">
							<div class="col">
								<h5>{{ quizTitle }}</h5>
							</div>
						</div>
						<div class="row">
							<div class="col">
								<h5 class="modal-title" v-if="questions && questions.length">Question {{ activeQuestionIndex + 1 }}
									/ {{ questions.length }}</h5>
								<h5 v-if="waitingToStart">Waiting to start</h5>
								<h5 v-if="loading">Fetching questions..</h5>
							</div>
						</div>
					</div>
				</div>
				<div class="modal-body">
					<div v-if="waitingToStart || loading">
						<img src="https://media1.tenor.com/images/0b1a92464aeec9ca412f92e87ff6125d/tenor.gif?itemid=10217720"
						     style="width: 83.3px; height: 117.7px;"/>
					</div>
					<div v-else-if="showFinalResults">
						<h2>Result</h2>

						<p>You got {{ correctCount }} out of {{ questions.length }} correct answers ({{ correctPercentage}}%).</p>
					</div>
					<div v-else-if="activeQuestion">
						<div>
							<question
									v-if="activeQuestion"

									:guid="activeQuestion.guid"
									:questionHtml="activeQuestion.questionHtml"
									:answers="activeQuestion.answers"
									:note="activeQuestion.note"
									:explanation="activeQuestion.explanation"
									:picture-url="activeQuestion.pictureUrl"
									:picture-text="activeQuestion.pictureText"
									:type="activeQuestion.type"
									:can-answer="answerResult === null"
									:show-result="answerResult !== null"

									v-on:nextQuestion="nextQuestion()"
									v-on:result="onQuestionResult($event)"
									v-on:selectedAnswerIndexesChanged="selectedAnswerIndexes = $event"
							/>
						</div>
						<div v-if="answerResult !== null">
							<p v-if="answerResult" class="answer-correct">
								<strong>Correct!</strong>
							</p>
							<p v-else class="answer-wrong">
								<strong>Wrong.</strong>
							</p>

							<div class="question-explanation" v-if="activeQuestion.explanation">
								<strong>Explanation:</strong><br />
								<br />
								<p>{{ activeQuestion.explanation }}</p>
							</div>
						</div>
					</div>
				</div>
				<div class="modal-footer" :class="activeQuestion ? 'modal-footer-question' : 'modal-footer-intro'">
					<div v-if="!activeQuestion">
						<div class="container text-left font-weight-bold">
							<label>Test</label>
							<select v-model="currentTest" class="form-control">
								<option value="">SELECT TEST</option>
								<optgroup v-for="(testGroup, i) of testGroups" :label="testGroup.title">
									<option v-for="(test, j) of testGroup.tests" :value="i + '.' + j">{{ test.title }}</option>
								</optgroup>
							</select>

							<label class="mt-2">Question count</label>
							<select v-model="questionCount" class="form-control">
								<option v-for="questionCount of questionCounts" :value="questionCount">{{ questionCount }}</option>
								<option value="all">{{ activeTest ? 'All questions (' + filterQuestions(activeTest.questions).length + ')' : 'All questions' }}</option>
							</select>

							<button class="btn btn-block mt-2" @click="startCurrentTest" :class="canStartTest ? 'btn-success' : 'btn-dark'" :disabled="!canStartTest">Start test</button>
						</div>
					</div>
					<div v-else>
						<button
								v-if="showFinalResults"
								class="btn btn-success"
								v-on:click="reset()"
								v-text="'Fetch new questions'"
						/>

						<button
								v-else-if="answerResult === null"
								class="btn btn-success"
								:class="!selectedAnswerIndexes.length ? 'btn-disabled' : ''"
								:disabled="!selectedAnswerIndexes.length"
								v-on:click="submitAnswer()"
								v-text="'Answer'"
						/>

						<button
								v-else-if="answerResult !== null"
								class="btn btn-secondary"
								v-on:click="nextQuestion()"
								v-text="'Next question'"
						/>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import Question from '@/components/questions/Question';
	import {testCollectionGroups} from '@/fixtures/tests';

	export default {
		name: 'question-container',
		components: {
			Question
		},
		data() {
			let questionCounts = [];

			for (let i = 5; i <= 50; i += 5) {
				questionCounts.push(i);
			}

			return {
				waitingToStart: true,
				loading: false,

				quizTitle: null,

				// Questions
				questions: null,
				activeQuestionIndex: null,

				// Results
				correctCount: 0,
				wrongCount: 0,
				answerResult: null,
				showFinalResults: false,

				// Answer indexes
				selectedAnswerIndexes: [],
				correctAnswerIndexes: [],

				testGroups: testCollectionGroups,

				questionCount: 30,
				questionCounts: questionCounts,

				currentTest: '',
			}
		},
		methods: {
			filterQuestion(question) {
				// Remove questions with no answers
				// TODO: Just show the image?
				if (!question.answers || question.answers.length <= 0) {
					return false;
				}

				return true;
			},
			filterQuestions(questions) {
				return questions.filter(this.filterQuestion);
			},
			startCurrentTest() {
				if (!this.currentTest) {
					alert('You must select a test to start!');

					return;
				}

				const test = this.activeTest;

				if (!test) {
					alert(`Could not find test ${this.currentTest}`);

					return;
				}

				this.startTest(test);
			},
			reset() {
				this.waitingToStart = true;

				this.quizTitle = null;
				this.questions = null;
				this.activeQuestionIndex = null;
				this.selectedAnswerIndexes = [];
				this.correctAnswerIndexes = [];
				this.loading = true;
				this.correctCount = 0;
				this.wrongCount = 0;
				this.showFinalResults = false;
				this.answerResult = null;
				this.showQuestionResult = false;
			},
			loadQuestions({ questions, title }) {
				this.waitingToStart = false;

				this.quizTitle = title;

				const questionsNormalized = [];

				let questionIndex = 0;

				const questionCount = this.questionCountInt;
				const questionOffset = 0;

				/*questions = questions.filter((question) => {
					if (question.pictureUrl) {
						return true;
					}

					if (question.questionNumber === 133) {
						return true;
					}

					if (question.questionText.match(/exhibit/gi)) {
						return true;
					}

					return false;
				});*/

				let randomQuestions = this.filterQuestions(questions)
					.sort(() => (Math.random() > 0.5) ? 1 : -1);

				console.log(questions, randomQuestions);

				if (this.questionCount !== 'all') {
					randomQuestions = randomQuestions.slice(questionOffset, questionOffset + questionCount);
				}

				for (const question of randomQuestions) {
					const answersNormalized = [];

					let answerIndex = 0;

					for (let answer of question.answers) {
						answersNormalized.push({
							index: answerIndex,
							guid: `answer-${questionIndex}-${answer.index}`,
							answerHtml: answer.answer,
							isCorrect: answer.isCorrect,
						});

						answerIndex++;
					}

					let questionHtml = question.questionNumber + ': ' + question.questionText;

					if (question.questionCode) {
						questionHtml += '<br /><br /><pre>' + question.questionCode + '</pre>';
					}

					questionsNormalized.push({
						guid: `question-${questionIndex}`,
						questionHtml: questionHtml,
						answers: answersNormalized,
						note: question.note || null,
						explanation: question.explanation || null,
						pictureUrl: question.pictureUrl || null,
						pictureText: question.pictureText || null,
						type: 'multipleAnswers',
					});

					questionIndex++;
				}

				this.questions = questionsNormalized;

				this.loading = false;
				this.nextQuestion();

				return;
				this.axios.get('https://party-quiz.extsrv.jalsoedesign.net/api/v1/question/index').then((response) => {
					if (response.data.success) {
						let data = response.data.data;

						this.questions = data;

						this.loading = false;

						this.nextQuestion(null);
					}
				})
			},
			nextQuestion() {
				if (this.activeQuestionIndex >= this.questions.length - 1) {
					this.showFinalResults = true;
				} else {
					this.showFinalResults = false;

					this.selectedAnswerIndexes = [];
					this.answerResult = null;

					if (this.activeQuestionIndex === null) {
						this.activeQuestionIndex = 0;
					} else if (this.activeQuestionIndex < this.questions.length - 1) {
						this.activeQuestionIndex++;
					}

					const correctAnswerIndexes = [];

					for (const answer of this.activeQuestion.answers) {
						if (answer.isCorrect) {
							correctAnswerIndexes.push(answer.index);
						}
					}

					console.log('correctAnswerIndexes', correctAnswerIndexes)

					this.correctAnswerIndexes = correctAnswerIndexes;
				}
			},
			submitAnswer() {
				const selectedAnswerIndexesJson = JSON.stringify(this.selectedAnswerIndexes.sort());
				const correctAnswerIndexesJson = JSON.stringify(this.correctAnswerIndexes.sort());

				let correct = selectedAnswerIndexesJson === correctAnswerIndexesJson;

				this.answerResult = correct;

				if (correct) {
					this.correctCount++;
				} else {
					this.wrongCount++;
				}
			},
			startTest(test) {
				this.loadQuestions(test);
			}
		},
		computed: {
			questionCountInt() {
				if (this.questionCount === 'all') {
					if (this.activeTest && this.activeTest.questions) {
						let questionCount = 0;

						for (const question of this.activeTest.questions) {
							if (question.answers && question.answers.length) {
								questionCount++;
							}
						}

						console.log('questionCount', questionCount, this.questionCount);
						return questionCount;
					}
				} else {
					return parseInt(this.questionCount, 10);
				}

				return undefined;
			},
			activeTest() {
				if (!this.currentTest) {
					return undefined;
				}

				const [ groupIndex, testIndex ] = this.currentTest.split(/\./g).map(v => parseInt(v, 10))

				return this.testGroups[groupIndex].tests[testIndex];
			},
			activeQuestion() {
				if (this.activeQuestionIndex === null) {
					return null;
				}

				return this.questions[this.activeQuestionIndex];
			},
			correctPercentage() {
				return ((this.correctCount / (this.correctCount + this.wrongCount)) * 100).toFixed(2);
			},
			canStartTest() {
				return this.questionCount && this.currentTest;
			}
		}
	}
</script>

<style lang="scss" scoped>
	.modal {
		position: relative;
		top: auto;
		right: auto;
		bottom: auto;
		left: auto;
		z-index: 1;
		display: block;
	}

	.modal-dialog {
	}

	.answer-correct {
		color: #0000aa;
	}

	.answer-wrong {
		color: #aa0000;
	}


	.question-explanation {
		background: #00aa00;
		padding: 10px;
		border-radius: 10px;
		color: white;
		white-space: pre-wrap;
	}

	.tests li {
		color: #8888ff;
		text-decoration: none;

		&:hover {
			text-decoration: underline;
			cursor: pointer;
		}
	}

	.modal-footer {
		&.modal-footer-question {

		}

		&.modal-footer-intro {
			justify-content: normal;

			> .row {
				width: 100%;
				text-align: left;

				ul {
					padding-left: 0px;
				}
			}
		}
	}
</style>
